import { ButtonBase, IconButton, useTheme } from '@mui/material';
import { Add } from '@mui/icons-material';
import './DefaultFree.scss';

interface DefaultFreeProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  onClick?: () => void;
}

const DefaultFree = ({
  title,
  description,
  price,
  image,
  onClick,
}: DefaultFreeProps) => {
  const theme = useTheme();

  return (
    <ButtonBase
      onClick={onClick}
      className="dish dish--default-free"
      component="div"
    >
      <img className="dish__image" src={image} />
      <div className="dish__body">
        {title ? <h3 className="dish__title">{title}</h3> : null}
        {description ? (
          <p className="dish__description">{description}</p>
        ) : null}
        {price ? <p className="dish__price">{price}</p> : null}
        <div className="dish__actions">
          <IconButton
            className="dish__btn-details"
            onClick={onClick}
            sx={{ backgroundColor: theme?.palette?.primary?.main }}
          >
            <Add className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};

export default DefaultFree;
